<template>
<span class="highsearch">
    <el-button class="searchbtn" type="primary" icon="el-icon-search" @click="clickSearch">{{$t("common.btnSearch")}}</el-button>
    <span class="btnline"></span>
    <el-button class="hidesearchbtn" type="primary" icon="el-icon-arrow-down" @click="opendialog"></el-button>
    <div class="searchalert theme" v-show="alertshow">
        <div class="triangle-top" v-show="alertshow"></div>
        <h1 style="margin-bottom:15px;">{{$t("searchdialog.title")}}</h1>
        <slot>default content</slot>
        <div class="serchbtn">
            <el-button type="primary" @click="clickAdvsearch">{{$t("common.btnSearch")}}</el-button>
            <el-button @click="opendialog">{{$t("common.btnUsual")}}</el-button>
        </div>
    </div>
</span>
</template>

<script>
export default {
    name:"searchdialog",
    data(){
        return{
            alertshow:false,
        }
    },
    methods:{
        opendialog(){
            if(this.alertshow){
                this.alertshow = false;
            }else{
                this.alertshow = true;
            }
        },
        clickSearch(){
            this.$emit('doSearch');
        },
        clickAdvsearch(){
            this.$emit('doAdvsearch');
            this.opendialog()
        }
    },
    
}
</script>

<style lang="less">
.highsearch{
    display: inline-block;
    position: relative;
    .searchbtn{
        border-radius: 3px 0px 0px 3px;
        height: 32px;
    }
    .hidesearchbtn{
        margin-left: 0px !important;
        border-radius: 0px 3px 3px 0px;
        height: 32px;
    }
    .btnline{
        position: absolute;
        display: inline-block;
        z-index: 1;
        top: 8px;
        width: 1px;
        height: 14px;
        background: #fff;
    }
    .searchalert{
        position: absolute;
        z-index:5;
        top: 38px;
        right: -130px;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0px 0px 3px rgba(68, 48, 96, 0.2);
        padding: 20px;
        h1{
            text-align: center;
        }
        ul{
            li{
                margin-bottom: 15px;
                display: flex;
                // justify-content: space-between;
                .el-input,.el-select{
                    width: 160px;
                }
                span{
                    display: inline-block;
                    width: 70px;
                    line-height: 32px;
                    text-align: right;
                }
                .el-range-editor--small .el-range-separator{
                    width: auto;
                    line-height: 24px;
                    margin-right: auto;
                }
                .el-range-editor.el-input__inner{
                    padding: 3px 5px;
                }
                .el-date-editor .el-range__close-icon{
                    width: 16px;
                }
                .el-date-editor--daterange.el-input__inner{
                    width: 240px;
                }
            }
        }
        .serchbtn{
            margin-top: 30px;
            text-align: center;
        }
        .triangle-top{
            position: absolute;
            top: -9px;
            margin-left:-6px;
            left: 50%;
            width: 0;
            height: 0;
            border-right: 6px solid transparent;
            border-bottom: 9px solid #fff;
            border-left: 6px solid transparent;
        }
    }
}
</style>